module.exports = __webpack_public_path__ + "src/assets/img/01_6art_3part_gallery.6061b158.jpg";